import { createFileRoute } from "@tanstack/react-router";

import MissingInfoTickets from "../pages/MissingInfoTickets";
import { useAppShell } from "../layouts/AppShellContext";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/missing-info-tickets")({
  component: MissingInfoTicketsRoute,
});

function MissingInfoTicketsRoute() {
  const { isSidebarOpen } = useAppShell();

  return (
    <RequireAuth>
      <MissingInfoTickets isSidebarOpen={isSidebarOpen} />
    </RequireAuth>
  );
}
